module.exports = __webpack_public_path__ + "img/logo.ec3cbb25.png";